import { useState } from "react";
import { Star, Trash2, ChevronLeft, ChevronRight, GripVertical } from "lucide-react";

const move = (list, from, to) => {
  const next = [...list];
  const [item] = next.splice(from, 1);
  next.splice(to, 0, item);
  return next;
};

function Tile({ u, i, count, dragging, over, handlers, onMain, onShift, onRemove }) {
  const main = i === 0;
  return (
    <div
      draggable
      {...handlers}
      className={`relative group border rounded-md overflow-hidden bg-[#F5F3ED] cursor-grab active:cursor-grabbing transition-[opacity,transform,box-shadow] ${
        dragging ? "opacity-40 scale-95" : ""
      } ${over ? "ring-2 ring-[#8C6C50] ring-offset-2" : ""} ${main ? "border-[#8C6C50]" : "border-[#E5E1D8]"}`}
      data-testid={`editor-photo-${i}`}
    >
      <img src={u} alt="" draggable={false} className="w-full h-28 object-cover pointer-events-none" />
      {main && (
        <span className="absolute top-1.5 left-1.5 bg-[#8C6C50] text-white text-[10px] tracking-wider px-1.5 py-0.5 rounded inline-flex items-center gap-1" data-testid="editor-photo-main-badge">
          <Star className="w-3 h-3 fill-white" /> PRINCIPALE
        </span>
      )}
      <GripVertical className="absolute top-1.5 right-1.5 w-4 h-4 text-white drop-shadow hidden md:block opacity-0 group-hover:opacity-100 transition-opacity" />
      <div className="absolute bottom-0 inset-x-0 flex items-center justify-between gap-1 p-1 bg-black/45 md:opacity-0 md:group-hover:opacity-100 transition-opacity">
        <div className="flex gap-1">
          <button type="button" disabled={i === 0} onClick={() => onShift(i, -1)} className="bg-white/90 p-1 rounded disabled:opacity-30" title="Déplacer à gauche" data-testid={`editor-photo-left-${i}`}>
            <ChevronLeft className="w-3 h-3" />
          </button>
          <button type="button" disabled={i === count - 1} onClick={() => onShift(i, 1)} className="bg-white/90 p-1 rounded disabled:opacity-30" title="Déplacer à droite" data-testid={`editor-photo-right-${i}`}>
            <ChevronRight className="w-3 h-3" />
          </button>
        </div>
        <div className="flex gap-1">
          {!main && (
            <button type="button" onClick={() => onMain(i)} className="bg-white/90 p-1 rounded text-[#8C6C50]" title="Choisir comme photo principale" data-testid={`editor-photo-set-main-${i}`}>
              <Star className="w-3 h-3" />
            </button>
          )}
          <button type="button" onClick={() => onRemove(i)} className="bg-rose-600 text-white p-1 rounded" title="Supprimer" data-testid={`editor-remove-image-${i}`}>
            <Trash2 className="w-3 h-3" />
          </button>
        </div>
      </div>
    </div>
  );
}

export function PhotoGrid({ images, onChange }) {
  const [drag, setDrag] = useState(null);
  const [over, setOver] = useState(null);
  if (!images.length) return null;

  const handlers = (i) => ({
    onDragStart: (e) => { setDrag(i); e.dataTransfer.effectAllowed = "move"; },
    onDragOver: (e) => { e.preventDefault(); if (over !== i) setOver(i); },
    onDragLeave: () => { if (over === i) setOver(null); },
    onDrop: (e) => {
      e.preventDefault();
      if (drag !== null && drag !== i) onChange(move(images, drag, i));
      setDrag(null);
      setOver(null);
    },
    onDragEnd: () => { setDrag(null); setOver(null); },
  });

  return (
    <div className="mb-3">
      <p className="text-xs text-[#888] mb-2">
        Glissez-déposez les photos pour les réordonner. La première est la photo principale (étoile pour la choisir).
      </p>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-testid="editor-photo-grid">
        {images.map((u, i) => (
          <Tile
            key={u}
            u={u}
            i={i}
            count={images.length}
            dragging={drag === i}
            over={over === i && drag !== i}
            handlers={handlers(i)}
            onMain={(k) => onChange(move(images, k, 0))}
            onShift={(k, d) => onChange(move(images, k, k + d))}
            onRemove={(k) => onChange(images.filter((_, j) => j !== k))}
          />
        ))}
      </div>
    </div>
  );
}
